module.exports = __webpack_public_path__ + "img/brlxzj.72c31535.png";